import { importProvidersFrom } from '@angular/core';
import { AuthStore } from '@mb/auth/client';
import { NgxPermissionsModule } from 'ngx-permissions';

export function provideWorkforceAuth() {
  return [AuthStore, importProvidersFrom(NgxPermissionsModule.forRoot())];
}
